import { MotionValue } from "motion/react"
import { createContext } from "react"

export const TickerItemContext = createContext<
    | {
          offset: MotionValue<number>
      }
    | undefined
>(undefined)
